// Module
var code = "<div class=\"js-popup-baloon{{#isShown}} show{{/isShown}}\">\r\n    <div class=\"lock-image\">\r\n        <svg>\r\n            <use xlink:href=\"assets/webdesktop/web-desktop-sprite.svg#{{iconUrl}}\"></use>\r\n        </svg>\r\n    </div>\r\n    <div class=\"js-text\">{{.text}}</div>\r\n</div>";
// Exports
export default code;